import styled from 'styled-components';
import React from 'react';
import { Headline, Checkbox, TextLink, } from '@oneaudi/unified-web-components';
import { SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT, SYS_BREAKPOINT_2_XL, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_XS, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_600, SYS_SPACE_RELATIVE_6_XL, } from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '../../utils/AlphaHelper';
import { SYS_SPACE_RELATIVE_3_XL, SYS_SPACE_RELATIVE_LG, SYS_SPACE_RELATIVE_XS, SYS_SPACE_RELATIVE_SM, SYS_SPACE_FIXED_500, SYS_SPACE_RELATIVE_MD, SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK, SYS_SPACE_FIXED_100, } from '@oneaudi/unified-web-alpha-common';
export const FieldsetWrapper = styled.div `
  width: 100%;
  margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_500)
    : dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_3_XL)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    /* ColorTiles are an exception as they start out side-by-side from m on */
    width: ${(props) => props.layoutWidth === '50' && props.isColorTypeCheckbox ? 'calc(50% - 20px)' : '100%'};
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_RELATIVE_6_XL, SYS_SPACE_FIXED_500)
    : dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_3_XL)};
    ${(props) => props.isPlpQuickFilters &&
    props.isColorTypeCheckbox &&
    `
    ${dynamicStyling({
        alpha: `
      width: calc(50% - 31px);
    `,
    })};`}
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper('48px', SYS_SPACE_FIXED_500)
    : dynamicStylingHelper('var(--spacing-relative-md)', SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 20px)' : '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper('48px', SYS_SPACE_FIXED_500)
    : dynamicStylingHelper('var(--spacing-relative-xl)', SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 34px)' : '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper('48px', SYS_SPACE_FIXED_500)
    : dynamicStylingHelper('28px', SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 26px)' : '100%')};
    ${(props) => props.isPlpQuickFilters &&
    props.isColorTypeCheckbox &&
    `
    ${dynamicStyling({
        alpha: `
      width: max-content;
    `,
    })};`}
`;
export const FieldsetOneCol = styled((props) => React.createElement("fieldset", Object.assign({}, props))) `
  /* width: 100%; */
  margin: 0;
  padding: 0;
  border-color: transparent;

  display: grid;
  column-gap: ${(props) => props.$isPlpQuickFilters && props.$isColorTypeCheckbox
    ? dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)
    : props.$isColorTypeCheckbox
        ? SYS_SPACE_FIXED_200
        : SYS_SPACE_FIXED_200};
  grid-template-columns: ${(props) => props.$isPlpQuickFilters && props.$isColorTypeCheckbox
    ? dynamicStylingHelper('repeat(2, 1fr)', 'repeat(4, 46px)')
    : props.$isColorTypeCheckbox
        ? 'repeat(2, 1fr)'
        : 'auto'};

  row-gap: ${(props) => props.$isPlpQuickFilters ? '0' : dynamicStylingHelper('0', SYS_SPACE_RELATIVE_LG)};

  ${(props) => props.$isColorTypeCheckbox &&
    props.$isPlpQuickFilters &&
    `
  ${dynamicStyling({
        alpha: `
      background-color: ${SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK};
      border-radius: 20px;
      padding: ${SYS_SPACE_FIXED_100};
      row-gap: ${SYS_SPACE_FIXED_150};
      margin-bottom: ${SYS_SPACE_RELATIVE_LG};

      @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
        padding-right: calc(${SYS_SPACE_FIXED_100} + 2px);
      }
    `,
    })};`}

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    /* ColorTiles are 3columns on 50% layouts and 4cols on 100%, checkboxes in the equipmentFilter are 4cols as well, all other filters are 2cols */
    ${(props) => {
    if ((props.$layoutWidth === '50' || props.$layoutWidth === '50/100') &&
        props.$isColorTypeCheckbox) {
        return `grid-template-columns: repeat(3, 88px)`;
    }
    if (props.$isColorTypeCheckbox) {
        return `grid-template-columns: repeat(4, 88px)`;
    }
    if (props.$isPartOfEquipmentFilter) {
        return `grid-template-columns: repeat(1, 1fr)`;
    }
    return `grid-template-columns: repeat(2, 1fr)`;
}};

    grid-auto-flow: row;
    column-gap: ${(props) => props.$isColorTypeCheckbox
    ? dynamicStylingHelper(SYS_SPACE_FIXED_200, SYS_SPACE_RELATIVE_XS)
    : SYS_SPACE_FIXED_300};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    /* ColorTiles are 4cols, all other filters are 2 or 4 cols */
    ${(props) => {
    if (props.$isColorTypeCheckbox) {
        return `grid-template-columns: repeat(4, 88px)`;
    }
    if (props.$layoutWidth === '50' ||
        props.$layoutWidth === '50/100' ||
        props.$isPartOfEquipmentFilter) {
        return `grid-template-columns: repeat(2, 1fr)`;
    }
    if (props.$isPlpQuickFilters) {
        return `grid-template-columns: repeat(1, 1fr)`;
    }
    return `grid-template-columns: repeat(3, 1fr)`;
}};
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 20px)' : '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    /* equipmentFilter checkboxes are 1col, colorTiles 4col, the other filters are 2col */
    width: ${(props) => (props.$layoutWidth === '50/100' ? 'calc(50% - 26px)' : '100%')};
    ${(props) => {
    if (props.$isPartOfEquipmentFilter) {
        return `
            grid-template-columns: repeat(1, 1fr)
            `;
    }
    if (props.$isColorTypeCheckbox) {
        return `grid-template-columns: repeat(4, 88px)`;
    }
    if (props.$isPlpQuickFilters) {
        return `grid-template-columns: repeat(1, 1fr)`;
    }
    return `grid-template-columns: repeat(4, 1fr)`;
}};
  }

  @media (min-width: ${SYS_BREAKPOINT_XS}) and (max-width: ${SYS_BREAKPOINT_SM}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: repeat(4, 46px);
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_SM}) and (max-width: ${SYS_BREAKPOINT_MD}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: repeat(5, 46px);
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) and (max-width: ${SYS_BREAKPOINT_LG}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: repeat(4, 46px);
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) and (max-width: ${SYS_BREAKPOINT_XL}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: ${dynamicStylingHelper('repeat(4, 46px,)', 'repeat(3, 46px)')};
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
          width: ${dynamicStylingHelper('100%', 'unset')};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) and (max-width: ${SYS_BREAKPOINT_2_XL}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: repeat(4, 46px);
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
          width: ${dynamicStylingHelper('100%', 'unset')};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    ${(props) => {
    if (props.$isPlpQuickFilters && props.$isColorTypeCheckbox) {
        return `
          grid-template-columns: repeat(5, 46px);
          column-gap: ${dynamicStylingHelper('16px', SYS_SPACE_FIXED_150)};
          width: ${dynamicStylingHelper('100%', 'unset !important')};
        `;
    }
    return ``;
}}
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    width: ${(props) => (props.$layoutWidth === '50/100' ? 'calc(50% - 34px)' : '100%')};
  }
`;
export const StyledCheckboxWrapper = styled.div `
  display: flex;
  margin-block-end: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_MD)
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, '0')};
  align-items: flex-start;

  &:last-child {
    margin-block-end: ${(props) => props.isPlpQuickFilters
    ? props.numberOfAdditionalCheckboxes > 0
        ? dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG)
        : '0'
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, '0')};
  }
`;
export const MoreOptionsButtonsWrapper = styled.div `
  margin-bottom: ${dynamicStylingHelper('48px', SYS_SPACE_FIXED_500)};
`;
export const StyledCheckbox = styled((props) => React.createElement(Checkbox, Object.assign({}, props))) `
  align-items: ${(props) => (props.isCarTypeIconCheckbox ? 'center' : 'unset')};
  max-width: 255px;

  input {
    height: 20px !important;
  }

  label {
    align-items: ${(props) => (props.isCarTypeIconCheckbox ? 'center' : 'flex-start')};
  }
`;
export const IconLabelWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const GroupHeading = styled.div `
  display: flex;
  margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_SM)
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG)};
`;
export const VisuallyHiddenLegend = styled.legend `
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  overflow: hidden;
  margin: -1px;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const LabelCountWrapper = styled.span `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: ${SYS_SPACE_FIXED_150};
`;
export const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  font-size: ${(props) => props.isPlpQuickFilters && '12px'};
  color: ${(props) => props.isPlpQuickFilters ? SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT : ''};
`;
export const StyledTextLink = styled((props) => React.createElement(TextLink, Object.assign({}, props))) `
  ${dynamicStyling({
    alpha: `
      text-decoration: none;
  `,
})};
`;
